var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col md:w-9/12 w-full"},[_c('vx-card',{staticClass:"mb-base",attrs:{"title":"Nueva factura"}},[_c('new-invoice')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }